export const EK_KONTO_URVAL_COLLECTION_NAME = 'EKKonto';
export const EKONOMISK_ANALYS_URVAL_USAGE_CODE = 'EKLOP';
export const EKONOMISK_ANALYS_URVAL_ROUTINE_ID = 0;

export const URVAL_CHECKLIST_NO_VALUE_DISPLAY_LABEL = 'Inget värde';
export const URVAL_CHECKLIST_NO_VALUE_VALUE = 'NO_VALUE';

/** Antal pixlar ett villkor kommer indenteras per nivå */
export const URVAL_INDENT = 50;
